import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const FilterButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Filter" id="filter-tooltip" placement="bottom">
      <ButtonComponent type="button" color="primary mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="fluent-mdl2:filter-descending" height="18"  />
        &nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

FilterButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}

export default FilterButtonComponent
